import { serviceName } from '../resources/serviceConstants';
import {
  GET_DEAL_EFFORT_REVIEWERS,
  GET_EFFORT_APPROVAL,
} from '../resources/endPoint';
export const getEffortApproverDetails = (roleId, status) => {
  let url = GET_EFFORT_APPROVAL;
  const queryParams = [];

  if (status) {
    queryParams.push(`status=${status}`);
  }

  if (roleId) {
    queryParams.push(`role_id=${roleId}`);
  }

  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const postEffortApproval = (data) => {
  return {
    url: GET_EFFORT_APPROVAL,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};


export const getDealEffortReviewers = (dealId) => {
  const url = `${GET_DEAL_EFFORT_REVIEWERS}?dealId=${dealId}`;

  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};
